import { apiConstants } from "../../../../utils/apiConstants";
import { apiTypes } from "../../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../../utils/getAxiosCancelToken";
import apiRequestType from "../../../apiRequestType";

let cancelToken;
const getClassName = () => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.COMMON.GET_CLASS_NAME,
    cancelToken
  );
};

export default getClassName;
